<div class="center-screen" *ngIf="userService.LMSUserLoggedIn$">
  <!-- <app-page-cardhead [PageName]="'Restricted Access'" [PageHeadWidth]=600></app-page-cardhead> -->
</div>
<div class="center-screen">
  <div class="image_block2">
    <div><img src="assets/finbond-mutual-bank.jpg" /></div>
  </div>
</div>
